export default {
  tabs: {
    online_shop: 'Online Shop',
    reservations: 'Reservierungen',
    storefront: 'Storefront',
  },
};
